import React from 'react';

const ConfirmModal = ({ message, onConfirm, onCancel }) => {
  const handleBackgroundClick = (event) => {
    if (event.target === event.currentTarget) {
      onCancel();
    }
  };
  
  return (
    <div className="modal" onClick={handleBackgroundClick}>
      <div className="modal-content">
        <p>{message}</p>
        <button onClick={onConfirm} className="bg-blue">はい</button>
        <button onClick={onCancel} className="bg-gray">いいえ</button>
      </div>
    </div>
  );
};

export default ConfirmModal;
